import { gql } from '@apollo/client';

export const CURRENT_USER_ACTIVITY_IDS = gql`
  query currentUserActivityIds($input: ActivityInput!) {
    activities: currentUserActivities(input: $input) {
      aggregate {
        count
      }
      edges {
        node {
          id
        }
      }
    }
  }
`;
